import { createAction, props } from "@ngrx/store";
import {
  JoliooCheckResponse,
  JoliooPharmacy,
  JoliooRedemption,
  JoliooReservation,
  JoliooVoucher,
} from "../../io/jolioo/voucher.types";

export const enum VOUCHER_ACTIONS {
  SET_AVAILABILITY = "[VOUCHER] SET_AVAILABILITY",
  SELECT_PHARMACY = "[VOUCHER] SELECT_PHARMACY",
  CHECK = "[VOUCHER] CHECK",
  CHECK_SUCCESS = "[VOUCHER] CHECK_SUCCESS",
  CHECK_ERROR = "[VOUCHER] CHECK_ERROR",
  RESERVE = "[VOUCHER] RESERVE",
  RESERVE_SUCCESS = "[VOUCHER] RESERVE_SUCCESS",
  RESERVE_ERROR = "[VOUCHER] RESERVE_ERROR",
  CONFIRM = "[VOUCHER] CONFIRM",
  CONFIRM_SUCCESS = "[VOUCHER] CONFIRM_SUCCESS",
  CONFIRM_ERROR = "[VOUCHER] CONFIRM_ERROR",
  CANCEL = "[VOUCHER] CANCEL",
  CANCEL_SUCCESS = "[VOUCHER] CANCEL_SUCCESS",
  CANCEL_ERROR = "[VOUCHER] CANCEL_ERROR",
  RESET = "[VOUCHER] RESET",
  NEXT = "[VOUCHER] NEXT",
}

/** Kommt aus dem `jolioo`-Block der Dashboard-Antwort. */
export const setVoucherAvailability = createAction(
  VOUCHER_ACTIONS.SET_AVAILABILITY,
  props<{ enabled: boolean; pharmacies: Array<JoliooPharmacy> }>(),
);

/** `null` ist die Abwahl — der Platzhalter im Dropdown. */
export const selectVoucherPharmacy = createAction(
  VOUCHER_ACTIONS.SELECT_PHARMACY,
  props<{ pharmacy: string | null }>(),
);

export const checkVoucher = createAction(
  VOUCHER_ACTIONS.CHECK,
  props<{ code: string; pharmacy: string }>(),
);

export const checkVoucherSuccess = createAction(
  VOUCHER_ACTIONS.CHECK_SUCCESS,
  props<{ voucher: JoliooCheckResponse }>(),
);

export const checkVoucherError = createAction(
  VOUCHER_ACTIONS.CHECK_ERROR,
  props<{ error: any }>(),
);

export const reserveVoucher = createAction(
  VOUCHER_ACTIONS.RESERVE,
  props<{
    code: string;
    pharmacy: string;
    value: number;
    idempotencyKey: string;
  }>(),
);

export const reserveVoucherSuccess = createAction(
  VOUCHER_ACTIONS.RESERVE_SUCCESS,
  props<{ reservation: JoliooReservation }>(),
);

export const reserveVoucherError = createAction(
  VOUCHER_ACTIONS.RESERVE_ERROR,
  props<{ error: any }>(),
);

export const confirmVoucher = createAction(
  VOUCHER_ACTIONS.CONFIRM,
  props<{ code: string; pharmacy: string; idempotencyKey: string }>(),
);

export const confirmVoucherSuccess = createAction(
  VOUCHER_ACTIONS.CONFIRM_SUCCESS,
  props<{ redemption: JoliooRedemption }>(),
);

export const confirmVoucherError = createAction(
  VOUCHER_ACTIONS.CONFIRM_ERROR,
  props<{ error: any }>(),
);

export const cancelVoucher = createAction(
  VOUCHER_ACTIONS.CANCEL,
  props<{ code: string; pharmacy: string; idempotencyKey: string }>(),
);

export const cancelVoucherSuccess = createAction(
  VOUCHER_ACTIONS.CANCEL_SUCCESS,
  props<{ voucher: JoliooVoucher }>(),
);

export const cancelVoucherError = createAction(
  VOUCHER_ACTIONS.CANCEL_ERROR,
  props<{ error: any }>(),
);

export const resetVoucher = createAction(VOUCHER_ACTIONS.RESET);

/** Wie resetVoucher, behält aber die Apotheke: nach einer Einlösung geht es dort weiter. */
export const startNextVoucher = createAction(VOUCHER_ACTIONS.NEXT);
